import React, { useEffect, useState } from "react";
import reminderIcon from "../assets/icons/NotificationsIcons/reminder 1.png";
import sendIcon from "../assets/icons/NotificationsIcons/send (3) 1.png";
import { getData, postData } from "../axios/axiosHelper";
import toast from "react-hot-toast";

const SendNotificationsHooks = () => {
  const [global, setGlobal] = useState(true);

  const NavItems = [
    { name: "Notifications", to: "/notificationscenter", icon: reminderIcon },
    { name: "Send Notifications", to: "/sendnotifications", icon: sendIcon },
  ];

  
  useEffect(() => {
    setSelectedSellers([]);
    setSelectedUsers([]);
    setAllSellers(true);
    setAllUsers(true);
  }, [!global]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [sellers, setSellers] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedSellers, setSelectedSellers] = useState([]);
  const [allUsers, setAllUsers] = useState(true);
  const [allSellers, setAllSellers] = useState(true);
  const [image, setImage] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const getSellers = () => {
    setLoading(true);
    getData(`/seller`, true)
      .then((response) => {
        setSellers(response?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSellers();
  }, []);

  const getAllUsers = () => {
    setLoading(true);
    getData(`/user`, true)
      .then((response) => {
        const transformedUsers = response?.data?.data.map((user) => ({
          _id: user._id,
          name: `${user.firstName} ${user.lastName}`,
        }));
        setUsers(transformedUsers);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const handleImageUpload = (e) => setImage(e.target.files[0]);

  const [btnLoading, setBtnLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("body", body);
    image && formData.append("image", image);
    global && formData.append("global", global);
    (allUsers && !global) && formData.append("globalUsers", allUsers);
    (allSellers && !global) && formData.append("globalSellers", allSellers);
    if (!allUsers && selectedUsers.length > 0) {
      selectedUsers.forEach((id, index) => {
        formData.append(`users[${index}]`, id);
      })}
    if (!allSellers && selectedSellers.length > 0) {
      selectedSellers.forEach((id, index) => {
        formData.append(`sellers[${index}]`, id);
      })}
    postData("/notifications", formData, true)
      .then((response) => {
        setTitle("");
        setBody("");
        setImage(null);
        setSelectedUsers([]);
        setSelectedSellers([]);
        toast.success(response?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => setBtnLoading(false));
  };

  return {
    handleShow,
    show,
    handleClose,
    title,
    setTitle,
    body,
    setBody,
    setGlobal,
    allUsers,
    setAllUsers,
    selectedUsers,
    setSelectedUsers,
    handleImageUpload,
    handleSubmit,
    loading,
    users,
    global,
    btnLoading,
    NavItems,
    sellers,
    setSellers,
    setSelectedSellers,
    selectedSellers,
    setAllSellers,
    allSellers
  };
};

export default SendNotificationsHooks;